import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { language } = useLanguage();
  const [currentYear, setCurrentYear] = useState(null);

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year);
  }, []);

  return (
    <>
      <footer>
        <div className="social-links text-center py-3">
          <a href="https://www.youtube.com/@khatt.app1" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fab fa-youtube"></i>
          </a>
          <a href="https://apps.apple.com/us/app/khat-app/id6636479214" target="_blank" rel="noopener noreferrer" aria-label="App Store">
            <i className="fab fa-apple"></i>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.khat" target="_blank" rel="noopener noreferrer" aria-label="Google Play">
            <i className="fab fa-google-play"></i>
          </a>
        </div>
        <p className="text-white text-center py-4 fw_4">
          {language === "Arabic"
            ? `©${currentYear} خط. جميع الحقوق محفوظة.`
            : `©${currentYear} Khat. All rights reserved.`}
        </p>
      </footer>
    </>
  );
};

export default Footer;
